import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const NoDataStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: ${ct({ Dark: Colors.GreyDarker, Light: Colors.GreyDarker })};
`;
